<lib-page-container [title]="isAdding ? 'Add LuckyDraw Campaign' : 'Edit LuckyDraw Campaign'"
  [loading]="screen.isLoading()" [version]="appVersion.version" [apiVersion]="appVersion.apiVersion$ | async">
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <div lib-page-actions>
    <lib-button [disabled]="screen.isLoading()" *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]" (buttonClick)="onSave()" tooltip="Save" icon="save">Save</lib-button>
  </div>
  <div lib-page-body>
    <div class="flex-row gap-16">
      <app-campaign-base-edit #campaignBase [campaign]="campaign" fxFlex="490px"></app-campaign-base-edit>
      <mat-card appearance="outlined" fxFlex class="mat-typography">
        <mat-card-content>
          <mat-tab-group class="tab-group">
            <mat-tab label="Strategy">
              @if (campaign) {
                <app-lucky-draw-strategy #campaignStrategy [advertiserId]="advertiserId" [strategy]="campaign.strategy"></app-lucky-draw-strategy>
              }
            </mat-tab>

            <mat-tab label="Locations">
              <app-campaign-location-filters #campaignLocationFilters [campaignId]="campaignId"></app-campaign-location-filters>
            </mat-tab>

            <mat-tab label="Json">
              <pre>{{ campaign | json }}</pre>
            </mat-tab>

            @if (campaignId) {
              <mat-tab label="Media">
                <app-campaign-media #campaignMedia [campaignId]="campaignId"></app-campaign-media>
              </mat-tab>
            }

            <mat-tab label="Banner">
              <app-campaign-banner #campaignBanner></app-campaign-banner>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                Outbound Events
                @if (campaignOutboundEvents && campaignOutboundEvents.isValid() === false) {
                  <mat-icon class="tab-icon">warning</mat-icon>
                }
              </ng-template>
              <app-campaign-outbound-events #campaignOutboundEvents [campaignId]="campaignId"></app-campaign-outbound-events>
            </mat-tab>
          </mat-tab-group>

        </mat-card-content>
      </mat-card>
    </div>
  </div>
</lib-page-container>